import { useTranslation } from "react-i18next";
import { SITE } from "../config/site";
import { GOALS, reachGoal } from "../lib/metrika";
import { Icon } from "./Icon";

interface StoreBtnProps {
  store: "apple" | "play";
  tone: "secondary" | "white";
  className?: string;
}

// App Store / Google Play button. Every click records the downloadApp Metrica goal (0014).
export function StoreBtn({ store, tone, className }: StoreBtnProps) {
  const { t } = useTranslation();
  const apple = store === "apple";
  return (
    <a
      className={`btn btn-${tone} btn-store${className ? " " + className : ""}`}
      href={apple ? SITE.stores.appStore : SITE.stores.googlePlay}
      target="_blank"
      rel="noopener"
      onClick={() => reachGoal(GOALS.downloadApp)}
    >
      <Icon name={apple ? "g-apple" : "g-play"} className="glyph" />
      <span className="st">
        <small>{t("common.store_small")}</small>
        <b>{apple ? "App Store" : "Google Play"}</b>
      </span>
    </a>
  );
}
